import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../utils/services';
import { getFilterAsQueryString } from '../utils/routeUtils';

export const showBranchModal = (id) => {
  return {
    type: types.SHOW_BRANCH_MODAL,
    id
  };
}

export const hideBranchModal = () => {
  return {
    type: types.HIDE_BRANCH_MODAL
  };
}


export const resetBranchesData = (fields) => {
  return {
    type: types.RESET_BRANCHES_DATA,
    fields
  };
};
export const resetActivityBranchesData = (fields) => {
  return {
    type: types.RESET_ACTIVITY_BRANCHES_DATA,
    fields
  };
};
export const resetSBranchesData = (fields) => {
  return {
    type: types.RESET_S_BRANCHES_DATA,
    fields
  };
};
export const resetSActivityBranchesData = (fields) => {
  return {
    type: types.RESET_S_ACTIVITY_BRANCHES_DATA,
    fields
  };
};

export const updateBranchData = (field, value) => {
  return {
    type: types.UPDATE_BRANCH_DATA,
    field,
    value
  };
}

export const validateBranchData = (field, value) => {
  return {
    type: types.VALIDATE_BRANCH_DATA,
    field,
    value
  }
};

export const fetchBranches = (id, search, page, perPage, excludeDisabled, isLc, isLoadingDisabled, filters) => {
  return wrapCall(
    api.get(`/userB/branches?page=${page}&perPage=${perPage || 1000}${id ? '&businessId=' + id : ''}${search ? '&search=' + search : ''}${excludeDisabled ? '&excludeDisabled=' + excludeDisabled : ''}${isLc ? '&lc=en' : ''}${filters ? '&' + getFilterAsQueryString(filters) : ''}`),
    types.FETCH_BRANCHES,
    {id, isLoadingDisabled}
  );
};
export const fetchActivityBranches = (id, search, page, perPage, excludeDisabled, isLc, isLoadingDisabled, filters) => {
  return wrapCall(
    api.get(`/business/branches?page=${page}&perPage=${perPage || 1000}${id ? '&businessId=' + id : ''}${search ? '&search=' + search : ''}${excludeDisabled ? '&excludeDisabled=' + excludeDisabled : ''}${isLc ? '&lc=en' : ''}${filters ? '&' + getFilterAsQueryString(filters) : ''}`),
    types.FETCH_ACTIVITY_BRANCHES,
    { id, isLoadingDisabled }
  );
};
export const fetchSBranches = (id, search, page, perPage, excludeDisabled, isLc, isLoadingDisabled, filters) => {
  return wrapCall(
    api.get(`/business/branches?page=${page}&perPage=${perPage || 1000}${id ? '&businessId=' + id : ''}${search ? '&search=' + search : ''}${excludeDisabled ? '&excludeDisabled=' + excludeDisabled : ''}${isLc ? '&lc=en' : ''}${filters ? '&' + getFilterAsQueryString(filters) : ''}`),
    types.FETCH_S_BRANCHES,
    { id, isLoadingDisabled }
  );
};
export const fetchSActivityBranches = (id, search, page, perPage, excludeDisabled, isLc, isLoadingDisabled, filters) => {
  return wrapCall(
    api.get(`/business/branches?page=${page}&perPage=${perPage || 1000}${id ? '&businessId=' + id : ''}${search ? '&search=' + search : ''}${excludeDisabled ? '&excludeDisabled=' + excludeDisabled : ''}${isLc ? '&lc=en' : ''}${filters ? '&' + getFilterAsQueryString(filters) : ''}`),
    types.FETCH_S_ACTIVITY_BRANCHES,
    { id, isLoadingDisabled }
  );
};

export const fetchBranch = (id, isLc) => {
  return wrapCall(
    api.get(`/business/branches/${id}?${isLc ? 'lc=en': ''}`),
    types.FETCH_BRANCH,
    {id}
  );
};

export const createBranch = (data) => {
  return wrapCall(
    api.post(`/business/branches`, data),
    types.CREATE_BRANCH
  );
};

export const toggleBranchState = (id, newState) => {
  return wrapCall(
    api.post(`/business/branches/state/${id}`, {state: newState}),
    types.TOGGLE_BRANCH_STATE,
    {id, newState}
  );
};

export const updateBranch = (id, data) => {
  return wrapCall(
    api.put(`/business/branches/${id}`, data),
    types.UPDATE_BRANCH
  );
}

export const deleteBranch = (id) => {
  return wrapCall(
    api.delete(`/business/branches/${id}`),
    types.DELETE_BRANCH,
    {id}
  );
};
